export default __webpack_public_path__ + "static/media/angeloConrado.422465e3.jpg";